export default __webpack_public_path__ + "static/media/60.73669915.png";